import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';
import * as SendView from '../send-view/send-view.style';

export const StyledCloseButton = styled(SendView.StyledCloseButton)``;

export const StyledInputMount = styled(SendView.StyledInputMount)``;

export const StyledButtonWrapper = styled(SendView.StyledButtonWrapper)`
  &:not(:last-child) {
    margin-bottom: 130px;
  }
`;

export const StyledInputWrapper = styled(SendView.StyledInputWrapper)`
  margin-bottom: 20px;
`;

export const StyledInputLabel = styled(SendView.StyledInputLabel)``;

export const StyledInputValue = styled(SendView.StyledInputValue)``;

export const StyledTitle = styled.h3<{ mb?: string }>`
  text-align: center;
  margin-bottom: ${(props) => props.mb || '38px'};
  font-size: 28px;
  font-weight: ${themeGet('fontWeights.semiBold')};
  color: ${themeGet('colors.input.text')};
`;

export const StyledHolder = styled(SendView.StyledHolder)``;

export const StyledContainer = styled(SendView.StyledContainer)``;

export const StyledCircleIcon = styled(SendView.StyledCircleIcon)``;
